import styled from "styled-components";
import { FLEX } from "styles/flex";
import { calcRem } from "styles/theme";

export const Wrapper = styled.div`
  ${FLEX.FlexStartStart};
  flex-direction: column;
  gap: 16px;
  width: 100%;
  color: ${({ theme }) => theme.COLORS.WHITE};

  .section-title {
    font-weight: 500;
  }

  .section-desc {
    font-size: ${calcRem(14)};
    line-height: 1.5;
    color: ${({ theme }) => theme.COLORS.WHITE}80;
  }
`;

export const Section = styled.div`
  ${FLEX.FlexStartStart};
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

export const Box = styled.div`
  ${FLEX.FlexStartStart};
  flex-direction: column;
  gap: 10px;
  width: 100%;
  padding: 12px;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.COLORS.BUTTONS2}10;
  border: 1px solid ${({ theme }) => theme.COLORS.BUTTONS2}30;
  box-sizing: border-box;
  font-size: ${calcRem(14)};

  .box-title {
    font-weight: 500;
    color: ${({ theme }) => theme.COLORS.WHITE};
  }
`;

export const Row = styled.div`
  ${FLEX.FlexBetweenCenter};
  width: 100%;
  gap: 12px;
  font-size: ${calcRem(14)};

  .label {
    color: ${({ theme }) => theme.COLORS.WHITE}80;
    font-family: inherit;
  }

  .value {
    color: ${({ theme }) => theme.COLORS.WHITE};
    text-align: right;
    white-space: nowrap;
  }

  &.highlight .value {
    font-weight: 700;
    color: ${({ theme }) => theme.COLORS.BUTTONS2};
  }
`;

export const PeriodList = styled.div`
  ${FLEX.FlexStartStart};
  flex-direction: column;
  gap: 4px;
  width: 100%;
  color: ${({ theme }) => theme.COLORS.WHITE}90;

  .period-projected {
    color: ${({ theme }) => theme.COLORS.WHITE}60;
  }
`;

export const OrgList = styled.div`
  ${FLEX.FlexStartStart};
  flex-direction: column;
  gap: 10px;
  width: 100%;
`;

export const OrgRow = styled.div`
  ${FLEX.FlexStartStart};
  flex-direction: column;
  gap: 2px;
  width: 100%;

  .org-name {
    font-weight: 500;
    color: ${({ theme }) => theme.COLORS.WHITE};
  }

  .org-calc {
    font-size: ${calcRem(13)};
    color: ${({ theme }) => theme.COLORS.WHITE}80;
  }
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${({ theme }) => theme.COLORS.BUTTONS2}30;
`;

export const Footnote = styled.div`
  font-size: ${calcRem(12.5)};
  line-height: 1.5;
  color: ${({ theme }) => theme.COLORS.WHITE}60;
`;
